import { render, staticRenderFns } from "./FifoLedger.vue?vue&type=template&id=27c30fe5&"
import script from "./FifoLedger.vue?vue&type=script&lang=ts&"
export * from "./FifoLedger.vue?vue&type=script&lang=ts&"
import style0 from "./FifoLedger.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports